<template>
    <div>

        <!-- Table -->

        <trax-ui-card-icon-header header-color="info" icon="school" 
            :title="lang.polaris.dashboard.trainings" :actions="card_actions" :bus="bus">

            <enac-atpl-dashboard-registrations-table header-color="info" :bus="bus">
            </enac-atpl-dashboard-registrations-table>

        </trax-ui-card-icon-header>

        <!-- Search modal -->

        <trax-ui-modal-default :id="id+'-search'" :bus="bus" :title="lang.polaris.form.advanced_search">
            <enac-atpl-dashboard-registrations-search :id="id" :bus="bus"></enac-atpl-dashboard-registrations-search>
        </trax-ui-modal-default>

    </div>
</template>

<script>
    export default {
    
        props: {
            id: { default: 'home-registrations' },
        },

        data: function() {
            return {
                user: user,
                lang: lang,
                bus: new Vue()
            }
        },

        computed: {

            card_actions() {
                var actions = [];
                if (this.filterPermission) {
                    actions.push({ icon: 'search', event: this.id + '-search-open' });
                }
                return actions;
            },

            filterPermission() {
                return this.user.admin 
                    || this.user.permissions['dashboard.read-mine-locations']
                    || this.user.permissions['dashboard.read-all']
                    || this.user.permissions['dashboard.write-mine-locations']
                    || this.user.permissions['dashboard.write-all'];
            }
        }
    }
</script>
